export const SERVICE_FEATURE_LOADING = 'SERVICE_FEATURE_LOADING';
export const GET_SERVICE_FEATURES = 'GET_SERVICE_FEATURES';
export const GET_FEATURES = 'GET_FEATURES';
export const TYPE_SERVICE_FEATURE_LOADING = 'TYPE_SERVICE_FEATURE_LOADING';
export const SET_PARENTS_FEATURES = 'SET_PARENTS_FEATURES';
export const CLEAR_SERVICE_FEATURES = 'CLEAR_SERVICE_FEATURES';
export const RESET_PAGINATION_SERVICE_FEATURES = 'RESET_PAGINATION_SERVICE_FEATURES';
